import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";

const Input = ({
  type,
  value,
  name,
  onChange,
  placeholder,
  id,
  label,
  className,
  minLength,
  maxLength,
  pattern,
  disabled,
  required,
  checked,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
  };

  // Determine the input type based on whether it's a password and visibility state
  const inputType =
    type === "password" ? (isPasswordVisible ? "text" : "password") : type;
  return (
    <div className="input-wrapper">
      <label>{label}</label>
      <div className="password-input-container">
        <input
          type={inputType}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          id={id}
          className={className}
          minLength={minLength}
          maxLength={maxLength}
          required={required}
          pattern={pattern}
          disabled={disabled}
          checked={checked}
        />
        {type === "password" && (
          <button
            type="button"
            className="password-toggle"
            onClick={togglePasswordVisibility}
            aria-label={isPasswordVisible ? "Hide password" : "Show password"}
          >
            {isPasswordVisible ? (
              <FontAwesomeIcon icon={faEyeSlash} />
            ) : (
              <FontAwesomeIcon icon={faEye} />
            )}
          </button>
        )}
        {type === "checkbox" && (
          <label htmlFor={id}>
            &nbsp;I agree to the{" "}
            <a href="/terms-and-conditions">Terms and Conditions</a>
          </label>
        )}
      </div>
    </div>
  );
};

export default Input;
